import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import { Component, inject, LOCALE_ID, NgModule, OnDestroy } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { routes } from 'app/app.routes';
import { minAvgMaxAverageIndicator } from 'app/trello/plugins/min-avg-max-average-indicator';
import { minAvgMaxDrawZeros } from 'app/trello/plugins/min-avg-max-draw-zeros';
import { timeBasedTicks } from 'app/trello/plugins/time-based-ticks';
import { tooltipColorNormalizer } from 'app/trello/plugins/tooltip-color-normalizer';
import { WorkerScheduler } from 'app/trello/services/worker-scheduler';
import { Chart } from 'chart.js';
import { PrimeNG } from 'primeng/config';

registerLocaleData(localeEnGb);

Chart.register(
  minAvgMaxAverageIndicator,
  minAvgMaxDrawZeros,
  timeBasedTicks,
  tooltipColorNormalizer,
);

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
      {
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      },
    ),
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'en-GB'},
  ],
})
export class AppModule {
}

@Component({
  imports: [
    RouterOutlet,
  ],
  selector: 'app-root',
  template: `
      <router-outlet></router-outlet>
  `,
})
export class AppComponent implements OnDestroy {

  private readonly config: PrimeNG = inject(PrimeNG);
  private readonly workerScheduler = inject(WorkerScheduler);

  constructor() {
    this.config.theme.set({
      preset: definePreset(Aura, {
        semantic: {
          primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}',
          },
        },
      }),
    });

    window.addEventListener('beforeunload', () => {
      this.workerScheduler.terminateAllWorkers();
    });
  }

  ngOnDestroy(): void {
    this.workerScheduler.terminateAllWorkers();
  }

}
